import UserReliant from './UserReliant'

/**
 * Firestore definition
 */
export const completion = new UserReliant('completion')
export const notifications = new UserReliant('notifications')
